import { render } from "./iscsi.vue?vue&type=template&id=a4c07a42"
import script from "./iscsi.vue?vue&type=script&lang=js"
export * from "./iscsi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__